import React, { useImperativeHandle } from "react";
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import CxInput from '../../cx/CxInput';
import { useTranslation } from '../../hx/useTranslation';


const MxSlsDocFormClientData = props => {
  const [{ trans }] = useTranslation();

  // para cambiar datos del cliente en factura
  const rf_clientdata_txClient = React.useRef(null);
  const rf_clientdata_txIc = React.useRef(null);
  const rf_clientdata_txMobile = React.useRef(null);
  const rf_clientdata_txAddress = React.useRef(null);
  const rf_clientdata_txCity = React.useRef(null);
  const rf_clientdata_txState = React.useRef(null);
  const rf_clientdata_txPostalCode = React.useRef(null);

  useImperativeHandle(props.xref, () => {
    return {
      getType, getVal,
    };
  });
  const getType = () => { return 'MxSlsDocFormClientData' };

  const getVal = (field) => {
    // DEVUELVE EL VALOR EN EL CONTROL PEDIDO.
    switch (field) {
      case 'txClient': return rf_clientdata_txClient.current.getVal();
      case 'txIc': return rf_clientdata_txIc.current.getVal();
      case 'txMobile': return rf_clientdata_txMobile.current.getVal();
      case 'txAddress': return rf_clientdata_txAddress.current.getVal();
      case 'txCity': return rf_clientdata_txCity.current.getVal();
      case 'txState': return rf_clientdata_txState.current.getVal();
      case 'txPostalCode': return rf_clientdata_txPostalCode.current.getVal();
      default: break;
    }
  };

  React.useEffect(() => {
    // CARGA DATOS EN CONTROLES

    let idValue = '';
    let url = '';
    if (props.inInvoice) {
      idValue = props.inInvoice;
      url = 'sls/doc/i/r';
    }
    if (props.inReceipt) {
      idValue = props.inReceipt;
      url = 'sls/doc/r/r';
    }

    let record = {};
    record['idValue'] = idValue;
    Promise.all([FxFetch.doJsonX(url, record)]).then((result) => {
      if (result[0]) {
        FxLog.infox('MxSlsDocFormClientData.useEffect', '...result[0]:', result[0]);
        let rec = result[0].record[0];
        rf_clientdata_txClient.current.setVal(rec.txClient);
        rf_clientdata_txIc.current.setVal(rec.txIc);
        rf_clientdata_txMobile.current.setVal(rec.txMobile);
        rf_clientdata_txAddress.current.setVal(rec.txAddress);
        rf_clientdata_txCity.current.setVal(rec.txCity);
        rf_clientdata_txState.current.setVal(rec.txState);
        rf_clientdata_txPostalCode.current.setVal(rec.txPostalCode);
      }
    });

    // eslint-disable-next-line
  }, []);

  return (
    <div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }} >
        <CxInput xref={rf_clientdata_txClient} label={trans('field.client')} maxLength={100} width='var(--ibs_control_width_md)' />
        <CxInput xref={rf_clientdata_txIc} label={trans('field.ic')} maxLength={15} width='var(--ibs_control_width_md)' />
        <CxInput xref={rf_clientdata_txMobile} label={trans('field.mobile')} maxLength={20} width='var(--ibs_control_width_md)' />
        <CxInput xref={rf_clientdata_txAddress} label={trans('field.address')} width='var(--ibs_control_width_md)' maxLength={100} />
        <CxInput xref={rf_clientdata_txCity} label={trans('field.city')} maxLength={50} width='var(--ibs_control_width_md)' />
        <CxInput xref={rf_clientdata_txState} label={trans('field.state')} maxLength={50} width='var(--ibs_control_width_md)' />
        <CxInput xref={rf_clientdata_txPostalCode} label={trans('field.postal_code')} maxLength={10} width='var(--ibs_control_width_md)' />
      </div>

    </div>
  );
};

export default MxSlsDocFormClientData;
